import API from "../helpers/Api";
const querystring = require("querystring");

export const getUsuarioByToken = () => {
  return API.get(`rest/getUsuarioByToken`);
};

export const loginFatura = (user, password, orgao) => {
  return API.get(
    `rest/loginFatura?login=${user}&pwd=${password}&orgao=${orgao}`
  );
};
export const login = (user, password) => {
  let params = { login: user, pwd: password };
  return API.get(`login`, {
    params: params,
    paramsSerializer: function(params) {
      return querystring.stringify(params);
    }
  });
};
